export namespace BulkAddSetValuesModel {
  export enum ModeEnum {
    MANUAL_ENTRY = "MANUAL_ENTRY",
    AUTO_GENERATE = "AUTO_GENERATE",
  }

  export const defaultMode = ModeEnum.MANUAL_ENTRY;
}
